import { Input, Image, Text, View } from 'components';
import Base, { Config } from 'components/saleTool/Base';
import React from 'react';
import styles from './index.module.scss';
import { history } from 'modules/navigator';
import { user } from 'modules/saleTool/store';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

interface State {
  routes: any;
  name: string;
  password: string;
}


export default class Login extends Base {
  public config: Config = {
    navigationBarTitleText: '登录'
  };

  public state: State = {
    routes: [],
    name: "",
    password: ''
  };

  public didMount() {
    
  }

  private link = url => {
    history.push(url);
  }

  // private handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //     console.log(event.target.value)
  //     this.setState({
  //       name:event.target.value
  //     })
  // }

  private valueChange = (name,e) => {
    // console.log(name,e.target.value);
    this.setState({[name]:  e.target.value})
  }

  private checkInput = () => {
    if(this.state.name == '' || this.state.name.length != 11){
      toast.error("请输入正确手机号",{
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 2000,
        closeButton: false
      })
      return false;
    }
    if(this.state.password == ''){
      toast.error("请输入密码",{
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 2000,
        closeButton: false
      })
      return false;
    }
    return true;
  }
  
  private handleLogin = async() => {
    let that = this;
    if(!this.checkInput()){
      return;
    }
    
    const res = await this.apiClient.base.userApi({
      phone: this.state.name,
      password: this.state.password
    })
    if(res.status == 10000){
      user.setToken(res.body.token)
      toast.info("登录成功！",{
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
      setTimeout(function(){
        that.link('/saleTool/main')
      },800)
      
    }else {
      toast.error(res.msg,{
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 2000,
        closeButton: false,
        // onClose: function(){

        // }
      })
    }
  }


  public render() {
    const { name, password, routes } = this.state;

    return (
      <View className={styles.container}>
        <ToastContainer className={styles.ToastContainer}/>
        <View className={styles.Logo}>
          <Image
            className={styles.logoImg}
            src={this.assets.saleTool.logo}
          />
          <Text className={styles.logoTit}>销售管理平台</Text>
        </View>
        <View className={styles.form}>
          <Input
            value={name}
            name="name"
            className={styles.input}
            placeholder="请输入手机号"
            valueChange={this.valueChange}
          />
          <Input
            value={password}
            name="password"
            type="password"
            className={styles.input}
            placeholder="请输入密码"
            valueChange={this.valueChange}
          />
          <View className={styles.button} onClick={this.handleLogin}>立即登录</View>
        </View>
      </View>
    );
  }
}
